// INR-6255: 1:1-Port von src/application_steps.js.coffee (Coffee → JS).
//
// Handler für nested_form-Gem-Buttons (.add_fields / .remove_fields).
// Wird in Apply-Wizard-Views und Backend-Forms verwendet, die noch das
// link_to_add_fields / link_to_remove_fields Pattern nutzen:
//   - app/views/apply_steps/competency.html.haml
//   - app/views/apply_steps/languages.html.haml
//   - app/views/apply_steps/experiences.html.haml
//   - app/views/applicants/_documents.html.haml
//   - app/views/backend/applies/_form.html.haml
//
// Follow-up (eigenes Ticket, post-TISAX): Auf den bereits registrierten
// stimulus-rails-nested-form-Controller (data-controller="nested-form")
// migrieren. Infrastruktur ist in packs/backend.js und packs/application-tw.js
// bereits registriert – fehlt nur die Template-Migration in den 5 Views.

jQuery(() => {
  jQuery('form').on('click', '.add_fields', function(event) {
    event.preventDefault()
    const time = Date.now()
    const regexp = new RegExp(jQuery(this).data('id'), 'g')
    jQuery(this).before(jQuery(this).data('fields').replace(regexp, time))
  })

  jQuery('form').on('click', '.remove_fields', function(event) {
    event.preventDefault()
    jQuery(this).prev('input[type=hidden]').val('1')
    jQuery(this).closest('fieldset').hide()
  })
})
